import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { QueryKey } from '@/Config/api/queryKey';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';

export const useConversationTopicDelete = () => {
  const { t } = useTranslation('insights_page');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKey.conversationTopics.delete],
    onSuccess: (_, conversationTopicId) => {
      queryClient.setQueryData([QueryKey.conversationTopics.list], (prev: TopicDto[] | undefined) =>
        (prev ?? []).filter((item) => item.id !== conversationTopicId),
      );

      toast.success(t('toast.delete_topic.success'));
    },
    onError: () => {
      toast.error(t('toast.delete_topic.error'));
    },
  });

  const handleDeleteTopic = (conversationTopicId: number) => mutation.mutate(conversationTopicId);

  return { handleDeleteTopic };
};
